import { render } from "./Course.vue?vue&type=template&id=37167b4a&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=37167b4a&scoped=true&lang=css"
import "./Course.vue?vue&type=style&index=1&id=37167b4a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37167b4a"]])

export default __exports__